import React from 'react'
import PropTypes from 'prop-types'
import ToggleSwitch from './ToggleSwitch'

const ACTIVE = { id: 'active', label: 'active' } //active
const INACTIVE = { id: 'inactive', label: 'inactive' } //inactive
const OPTIONS = [ACTIVE, INACTIVE]

const BooleanToggleField = ({ value, onChange, disabled, t }) => (
    <ToggleSwitch
        options={OPTIONS}
        value={value ? ACTIVE : INACTIVE}
        onChange={option => onChange(option.id === 'active')}
        display="label"
        disabled={disabled}
        t={t}
    />
)

BooleanToggleField.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
}

export default BooleanToggleField